// extracted by mini-css-extract-plugin
export default {"table":"reportTable_table__TiFLN","head":"reportTable_head__d8ljO","row":"reportTable_row__kBZ3E"};